<ion-content *ngIf="isApp; else webContent" class="ion-padding">
  <ion-refresher (ionRefresh)="handleRefresh()" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ion-content>

<ng-template #webContent>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
  <ng-container>
    <section [ngClass]="(isWebSite$ | async) ? 'page_site' : 'page_cabinet'" class="page">
      <app-header
        [isWebSite]="isWebSite$ | async"
        [navItems]="navItems"
        [phones]="phones"
        [steps]="steps"
        [webSiteItems]="webSiteItems"
      ></app-header>
      <div class="page-container">
        <div class="page-content">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-footer
        [annex]="annex"
        [emails]="emails"
        [isWebSite]="isWebSite$ | async"
        [mod]="true"
        [phones]="phones"
        [routes]="footerWebsiteItems"
      ></app-footer>
    </section>
  </ng-container>
</ng-template>
